import { useContext } from 'react';
import Header from '../Header/Header';
import Visibility from '../Visibility/Visibility';
import { UserContext } from '../../../context/userContext';
import css from './FullScreen.module.css';
import HelpFooter from '../HelpFooter/HelpFooter';
type BackgroundType = 'image' | 'color';

type FullScreenProps = {
  hideHeader?: boolean;
  background?: BackgroundType;
  children: React.ReactNode;
};

const FullScreen = ({ 
  hideHeader, 
  background = 'image',
  children 
}: FullScreenProps) => {
  const { user } = useContext(UserContext);
  const shouldHideHeader = hideHeader || !user;
  
  const containerClass = `${css.fullScreen} ${background === 'color' ? css.colorBackground : css.imageBackground}`;

  return (
    <div className={containerClass}>
      <Visibility visible={!shouldHideHeader}>
        <Header />
        <HelpFooter />
      </Visibility>
      {children}
    </div>
  );
};

export default FullScreen;